<template lang="pug">
.container
  h4 {{ newEditedDevice.DeviceProperties.length > 0 ? $t('') : $t('Device has no Properties defined') }}
    el-button.float-right(id="EditProperties-showAddProperty" type='success', size="mini", @click='showNewPropertyForm()', :title='$t("New property")')
      font-awesome-icon(icon="plus")
  .properties
    table
      tr(v-if='newEditedDevice.DeviceProperties && newEditedDevice.DeviceProperties.length > 0')
        th {{ $t('Name') }}
        th {{ $t('Body') }}
        th
      tr.property-row(v-for='property in newEditedDevice.DeviceProperties', :key='property.id', :id="'EditProperties-row' + property.id")
        td {{ property.name }}
        td {{ property.body }}
        td
          .float-right
            el-button(:id="'EditProperties-deleteProperty' + property.id", @click='deleteProperty(property)', :title='$t("Delete property")', type='success', size='mini')
              font-awesome-icon.button(icon="trash")
            span &nbsp;
            span &nbsp;
            span &nbsp;
            el-button(:id="'EditProperties-editProperty' + property.id", @click='editProperty(property)', :title='$t("Edit property")', type='success', size='mini')
              font-awesome-icon.button(icon="edit")
  el-dialog(:close-on-click-modal="false", :visible.sync='editPropertyFormVisible', append-to-body, @close='closeEditPropertyForm()')
    el-row
      el-col(:span="22")
        h4 {{$t('Edit property')}}
    el-row
      el-col(:span="24")
        el-form(:model='editedProperty', :size="uxParam('formSize')", label-width="120px")
          el-form-item(:label="$t('Name')")
            el-input(id="EditProperties-editNameInput", :placeholder='$t("name")', v-model='editedProperty.name')
          el-form-item(:label="$t('Body')")
            el-input(id="EditProperties-editBodyInput", :placeholder='$t("body")', v-model='editedProperty.body')
          el-button.float-right(id="EditProperties-editSaveButton", type='success', size="mini", @click='saveProperty()' :disabled="isSaving")
            span {{ isSaving ? $t('saving...') : $t('Save Device property')}}
  el-dialog(:close-on-click-modal="false", :visible.sync='addPropertyFormVisible', append-to-body, @close='closeEditPropertyForm()')
    el-row
      el-col(:span="22")
        h4 {{$t('Add property')}}
    el-row
      el-col(:span="24")
        el-form(:model='newProperty', :size="uxParam('formSize')", label-width="120px")
          el-form-item(:label="$t('Name')")
            el-input(id="EditProperties-addNameInput" :placeholder='$t("name")', v-model='newProperty.name')
          el-form-item(:label="$t('Body')")
            el-input(id="EditProperties-addBodyInput" :placeholder='$t("body")', v-model='newProperty.body')
          el-button.float-right(id="EditProperties-addSaveButton" type='success', size="mini", @click='createNewProperty()' :disabled="isSaving")
            span {{ isSaving ? $t('saving...') : $t('Add Device property')}}
</template>

<script>
import Vue from 'vue'

export default {
  props: ['side', 'newEditedDevice'],
  created () {
  },
  data () {
    return {
      errors: {
      },
      addPropertyFormVisible: false,
      editPropertyFormVisible: false,
      newProperty: {},
      editedProperty: {},
      isSaving: false
    }
  },
  methods: {
    async deleteProperty (property) {
      await Vue.axios
        .delete('deviceProperty/' + property.id)
      this.$emit('reloadDevice')
    },
    async createNewProperty () {
      this.isSaving = true
      await Vue.axios
        .post('deviceProperty', { Device: this.newEditedDevice.id, name: this.newProperty.name, body: this.newProperty.body })
      this.isSaving = false
      this.$emit('reloadDevice')
    },
    editProperty (property) {
      this.editedProperty = property
      this.showEditPropertyForm()
    },
    async saveProperty () {
      this.isSaving = true
      await Vue.axios
        .patch(`deviceProperty/${this.editedProperty.id}`, { name: this.editedProperty.name, body: this.editedProperty.body })
      this.isSaving = false
      this.$emit('reloadDevice')
    },
    showNewPropertyForm () {
      this.addPropertyFormVisible = true
    },
    closeNewPropertyForm () {
      this.addPropertyFormVisible = false
    },
    showEditPropertyForm () {
      this.editPropertyFormVisible = true
    },
    closeEditPropertyForm () {
      this.editPropertyFormVisible = false
    }
  },
  computed: {
    devices () {
      return this.$store.state.Device.device_list
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
</style>



// WEBPACK FOOTER //
// src/components/Device/EditProperties.vue